<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <div class="alert alert-secondary" role="alert">
          O dashboard sintético agrupa a informação de todas as corporações.
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-form inline>
          <label class="mr-sm-2" for="txt-data-inicio">De </label>
          <b-form-input type="date"
            id="txt-data-inicio"
            v-model="filtros.dataInicio"
            class="mb-2 mr-sm-2 mb-sm-0"
          ></b-form-input>
          <label class="mr-sm-2" for="txt-data-fim"> a </label>
          <b-form-input type="date"
            id="txt-data-fim"
            v-model="filtros.dataFim"
            class="mb-2 mr-sm-2 mb-sm-0"
          ></b-form-input>
          <b-button variant="primary" class="form-control" @click="initialize">Aplicar</b-button>
        </b-form>
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-atual">
          <b-card-body class="pb-0">
            <!-- <b-dropdown class="float-right" variant="transparent p-0" right>
              <template slot="button-content">
                <i class="icon-settings"></i>
              </template>
              <b-dropdown-item>Action</b-dropdown-item>
              <b-dropdown-item>Another action</b-dropdown-item>
              <b-dropdown-item>Something else here...</b-dropdown-item>
              <b-dropdown-item disabled>Disabled action</b-dropdown-item>
            </b-dropdown> -->
            <h4 class="mb-0">{{usuariosCount.destaque.atual}}</h4>
            <p>Usuários atual</p>
          </b-card-body>
          <card-line-chart v-if="usuariosCount.loaded" :chart-data="usuariosCount.atual" chartId="card-chart-usuarios-atual" class="chart-wrapper px-3" style="height:70px;" :height="70"/>
        </b-card>
      </b-col>

      <b-col sm="6" lg="3">
        <b-card no-body class="bg-total">
          <b-card-body class="pb-0">
            <h4 class="mb-0">{{usuariosCount.destaque.total}}</h4>
            <p>Usuários total</p>
          </b-card-body>
          <card-line-chart v-if="usuariosCount.loaded" :chart-data="usuariosCount.total" chartId="card-chart-usuarios-total" class="chart-wrapper px-3" style="height:70px;" :height="70"/>
        </b-card>
      </b-col>
      
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-pico">
          <b-card-body class="pb-0">
            <h4 class="mb-0">{{usuariosCount.destaque.pico}}</h4>
            <p>Usuários pico</p>
          </b-card-body>
          <card-line-chart v-if="usuariosCount.loaded" :chart-data="usuariosCount.pico" chartId="card-chart-usuarios-pico" class="chart-wrapper px-3" style="height:70px;" :height="70"/>
        </b-card>
      </b-col>
      
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-ativos">
          <b-card-body class="pb-0">
            <h4 class="mb-0">{{usuariosCount.destaque.ativos}}</h4>
            <p>Usuários ativos</p>
          </b-card-body>
          <card-line-chart v-if="volumes.loaded" :chart-data="usuariosCount.ativos" chartId="card-chart-usuarios-ativos" class="chart-wrapper px-3" style="height:70px;" :height="70"/>
        </b-card>
      </b-col>
    </b-row>

    <b-card>
      <b-row>
        <b-col sm="5">
          <h3 id="traffic" class="card-title mb-0">Volumes</h3>
          <!-- <div class="small text-muted">Setembro 2019</div> -->
        </b-col>
      </b-row>
      <volumes-chart chartId="volumes-chart" class="chart-wrapper" style="height:300px;margin-top:20px;" height="300" v-if="volumes.loaded" :chart-data="volumes.data"></volumes-chart>
      <div slot="footer">
        <b-row class="text-center">
          <b-col class="mb-sm-2 mb-0">
            <!-- <div class="text-muted">Assinaturas</div> -->
            <strong>{{this.volumes.totais.assinaturas}} Assinaturas</strong>
            <b-progress height={} class="progress-xs mt-2" :precision="1" variant="assinaturas" :value="50"></b-progress>
          </b-col>
          <b-col class="mb-sm-2 mb-0">
            <!-- <div class="text-muted">Autenticações</div> -->
            <strong>{{this.volumes.totais.autenticacoes}} Autenticações</strong>
            <b-progress height={} class="progress-xs mt-2" :precision="1" variant="autenticacoes" :value="50"></b-progress>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import CardLineChart from '../dashboard/CardLineChart'
import VolumesChart from '../dashboard/VolumesChart'
import { getStyle } from '@coreui/coreui/dist/js/coreui-utilities'
import axios from 'axios'
import { requestError, env, isAllowed } from '@/shared/utils'
import _ from 'underscore'
import { mapState } from 'vuex'
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'dashboard',
  components: {
    CardLineChart,
    VolumesChart
  },
  data: function () {
    let dtInicio = new Date();
    dtInicio.setDate(dtInicio.getDate() - 10);
    return {
      filtros: {
        dataInicio: dtInicio.toISOString().substr(0, 10),
        dataFim: new Date().toISOString().substr(0, 10)
      },
      usuariosCount: {
        loaded: false,
        total: null,
        atual: null,
        pico: null,
        ativos: null,
        destaque: {}
      },
      volumes: {
        loaded: false,
        data: null,
        totais: {}
      }
    }
  },
  async mounted () {
    if (!isAllowed('has_corporation')) {
      return this.$router.replace({path: '/clean'});
    }
    await this.initialize();
  },
  computed: {
    ...mapState(['corporationSelected'])
  },
  watch: {
    async corporationSelected(corporation) {
      await this.initialize();
    }
  },
  methods: {
    async initialize () {
      this.usuariosCount.loaded = false;
      this.volumes.loaded = false;
      await this.getUsersCount();
      await this.getOperationCount();
    },
    async getUsersCount () {
      var _this = this;
      const loader = _this.$loading.show();
      await axios
        .get(`${env.urlBillingApi}/users-count?initDate=${this.filtros.dataInicio}&endDate=${this.filtros.dataFim}&allCorporations=true&userClass=user_corporation`)
        .then(function(response) {
          _this.usersCount = {};
          var sortedUsers = _.sortBy(response.data._embedded.users_count, (itm) => itm.day.date);
          for (let k in sortedUsers) {
            let itm = sortedUsers[k];
            let split = itm.day.date.match(/(\d{4})-(\d{2})-(\d{2})/).slice(2);
            _this.usersCount[split.reverse().join("/")] = {
              currentUsers: itm.currentUsers,
              peakUsers: itm.peakUsers,
              totalUsers: itm.totalUsers
            };
          };
          _this.fillChartDataUsersCount();
          _this.usuariosCount.loaded = true;
          console.log(response.data);
          loader.hide();
        })
        .catch(function(error) {
          requestError(error);
          loader.hide();
        })
        .finally(() => {
          _this.loadCount--;
          loader.hide();
        });
    },

    fillChartDataUsersCount() {
      var labels = Object.keys(this.usersCount);
      var values = Object.values(this.usersCount);
      this.usuariosCount.atual = {
        labels: labels,
        datasets: [
          {
            label: 'Usuários atual',
            backgroundColor: 'rgba(255,255,255,.55)',
            fill: false,
            borderColor: 'rgba(255,255,255,.55)',
            data: values.map((itm) => itm.currentUsers)
          }
        ]
      }
      this.usuariosCount.total = {
        labels: labels,
        datasets: [
          {
            label: 'Usuários total',
            backgroundColor: 'rgba(255,255,255,.55)',
            fill: false,
            borderColor: 'rgba(255,255,255,.55)',
            data: values.map((itm) => itm.totalUsers)
          }
        ]
      }
      this.usuariosCount.pico = {
        labels: labels,
        datasets: [
          {
            label: 'Usuários pico',
            backgroundColor: 'rgba(255,255,255,.55)',
            fill: false,
            borderColor: 'rgba(255,255,255,.55)',
            data: values.map((itm) => itm.peakUsers)
          }
        ]
      }

      this.usuariosCount.destaque.atual = values.length == 0 ? 0 : parseInt(values[values.length - 1].currentUsers);
      this.usuariosCount.destaque.total = values.length == 0 ? 0 : parseInt(values[values.length - 1].totalUsers);
      this.usuariosCount.destaque.pico = values.length == 0 ? 0 : parseInt(values.reduce(function(a, b) { 
          return (parseInt(a.peakUsers) > parseInt(b.peakUsers)) ? a : b;
        }).peakUsers);
    },

    async getOperationCount () {
      var _this = this;
      const loader = _this.$loading.show();
      await axios
        .get(`${env.urlBillingApi}/operation-count?initDate=${this.filtros.dataInicio}&endDate=${this.filtros.dataFim}&allCorporations=true`)
        .then(function(response) {
          _this.operationCount = {};
          var sortedOperations = _.sortBy(response.data._embedded.operation_count, (itm) => itm.day.date);
          for (let k in sortedOperations) {
            let itm = sortedOperations[k];
            let split = itm.day.date.match(/(\d{4})-(\d{2})-(\d{2})/).slice(2);
            let day = split.reverse().join("/");
            _this.operationCount[day] || (_this.operationCount[day] = {});
            _this.operationCount[day][itm.operationType] = itm.count;
          };
          _this.fillChartDataOperationCount();
          _this.volumes.loaded = true;
          console.log(response.data);
          loader.hide();
        })
        .catch(function(error) {
          requestError(error);
          loader.hide();
        })
        .finally(() => {
          loader.hide();
        });
    },

    fillChartDataOperationCount() {
      var labels = Object.keys(this.operationCount);
      var values = Object.values(this.operationCount);
      this.usuariosCount.ativos = {
        labels: labels,
        datasets: [
          {
            label: 'Usuários ativos',
            backgroundColor: 'rgba(255,255,255,.55)',
            fill: false,
            borderColor: 'rgba(255,255,255,.55)',
            data: values.map((itm) => itm.any)
          }
        ]
      }
      if (!values.length) {
        this.usuariosCount.destaque.ativos = 0;
      } else {
        this.usuariosCount.destaque.ativos = parseInt(values[values.length - 1].any);
      }

      this.volumes.data = {
        labels: labels,
        assinaturas: values.map((itm) => parseInt(itm.signature || 0)),
        autenticacoes: values.map((itm) => parseInt(itm.login || 0))
      }
      this.volumes.totais = {
        assinaturas: values.reduce((mem, itm) => mem + parseInt(itm.signature || 0), 0),
        autenticacoes: values.reduce((mem, itm) => mem + parseInt(itm.login || 0), 0)
      }
    },
  }
}
</script>

<style lang="scss" scoped>
  /* IE fix */
  #card-chart-usuarios-atual, #card-chart-usuarios-total, #card-chart-usuarios-pico, #card-chart-usuarios-ativos, #volumes-chart {
    width: 100% !important;
  }
  .bg-ativos {
    background-color: #6b79ab;
    border: 1px solid #6b79ab;
    font-family: 'Helvetica-Bold';
    color: #ffffff;
    -webkit-box-shadow: 0px 0px 19px -2px rgba(0,0,0,0.75);
    -moz-box-shadow: 0px 0px 19px -2px rgba(0,0,0,0.75);
    box-shadow: 0px 0px 19px -2px rgba(0,0,0,0.75);
  }
  .bg-pico {
    background-color: #5f6fa7;
    border: 1px solid #5f6fa7;
    font-family: 'Helvetica-Bold';
    color: #ffffff;
    -webkit-box-shadow: 0px 0px 19px -2px rgba(0,0,0,0.75);
    -moz-box-shadow: 0px 0px 19px -2px rgba(0,0,0,0.75);
    box-shadow: 0px 0px 19px -2px rgba(0,0,0,0.75);
  }
  .bg-total {
    background-color: #5869a7;
    border: 1px solid #5869a7;
    font-family: 'Helvetica-Bold';
    color: #ffffff;
    -webkit-box-shadow: 0px 0px 19px -2px rgba(0,0,0,0.75);
    -moz-box-shadow: 0px 0px 19px -2px rgba(0,0,0,0.75);
    box-shadow: 0px 0px 19px -2px rgba(0,0,0,0.75);
  }
  .bg-atual {
    background-color: #5164a9;
    border: 1px solid #5164a9;
    font-family: 'Helvetica-Bold';
    color: #ffffff;
    -webkit-box-shadow: 0px 0px 19px -2px rgba(0,0,0,0.75);
    -moz-box-shadow: 0px 0px 19px -2px rgba(0,0,0,0.75);
    box-shadow: 0px 0px 19px -2px rgba(0,0,0,0.75);
  }
  .card-body h4 {
    font-size: 45px !important;
  }
  .card-body p {
    font-family: 'Helvetica-Light';
  }
</style>
